import React from 'react';
import get from 'lodash/get';

class GiphyButton extends React.Component {
  render() {
    return (
      <span
        onClick={this.props.toggleGiphyPanel}
        className="giphy-btn tooltip mrm"
        data-tooltip="GIF"
      >
        <span className="btn-static">
          <span className="vcenter">
            <span className="vcenter-inner">
              <img width="28" height="28" src={`${get(globals, 'staticImageUri', '/')}gif.png`} />
            </span>
          </span>
        </span>
      </span>
    );
  }
}

module.exports = GiphyButton;
